import React from "react";
import "../schedule/Schedule.css"; // Reuse CSS

const ObservationType = () => {
  return (
    <div className="schedule-container">
      <div className="schedule-header">
        <h2>Observation Type</h2>
        <button className="btn-primary">Add Observation Type</button>
      </div>

      <div className="week-section">
        <table
          className="observation-table"
          style={{ width: "100%", padding: "20px" }}
        >
          <thead>
            <tr>
              <th style={{ padding: "15px" }}>Name</th>
              <th style={{ padding: "15px" }}>Status</th>
              <th style={{ padding: "15px" }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ padding: "15px" }}>PPE</td>
              <td style={{ padding: "15px" }}>
                <span
                  style={{
                    color: "green",
                    background: "#e6fffa",
                    padding: "5px 10px",
                    borderRadius: "15px",
                  }}
                >
                  Active
                </span>
              </td>
              <td style={{ padding: "15px" }}>Edit | Delete</td>
            </tr>
            <tr>
              <td style={{ padding: "15px" }}>Work Environment</td>
              <td style={{ padding: "15px" }}>
                <span
                  style={{
                    color: "green",
                    background: "#e6fffa",
                    padding: "5px 10px",
                    borderRadius: "15px",
                  }}
                >
                  Active
                </span>
              </td>
              <td style={{ padding: "15px" }}>Edit | Delete</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ObservationType;
